/* Bellapoopis · experiencia 3D */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var HEART = 'M100 186 C56 158 8 124 8 74 C8 38 34 14 66 14 C82 14 94 22 100 34 C106 22 118 14 134 14 C166 14 192 38 192 74 C192 124 144 158 100 186 Z';
  var PAW = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="12" cy="15.5" rx="5" ry="4.2"/><ellipse cx="5.6" cy="10" rx="2" ry="2.5" transform="rotate(-25 5.6 10)"/><ellipse cx="9.4" cy="6.2" rx="2" ry="2.6" transform="rotate(-8 9.4 6.2)"/><ellipse cx="14.6" cy="6.2" rx="2" ry="2.6" transform="rotate(8 14.6 6.2)"/><ellipse cx="18.4" cy="10" rx="2" ry="2.5" transform="rotate(25 18.4 10)"/></svg>';
  var HEART_SVG = '<svg viewBox="0 0 200 200" fill="currentColor"><path d="' + HEART + '"/></svg>';

  /* cabecera */
  var header = document.querySelector('[data-bp-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    var burger = header.querySelector('[data-bp-burger]');
    var nav = header.querySelector('[data-bp-nav]');
    if (burger && nav) burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') !== 'true';
      burger.setAttribute('aria-expanded', open); nav.classList.toggle('is-open', open);
    });
  }

  /* reveal 3D */
  var revealEls = document.querySelectorAll('[data-bp-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else revealEls.forEach(function (el) { el.classList.add('is-in'); });

  /* tilt 3D */
  if (finePointer && !reduce) {
    document.querySelectorAll('[data-bp-tilt]').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-bp-tilt')) || 10;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((px - .5) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((.5 - py) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        el.style.transition = 'transform .12s linear, box-shadow .5s';
      });
      el.addEventListener('pointerleave', function () {
        el.style.transition = '';
        el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* tarjetas que giran */
  document.querySelectorAll('.bp-flip').forEach(function (el) {
    el.addEventListener('click', function () { if (!finePointer) el.classList.toggle('is-flipped'); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.classList.toggle('is-flipped'); } });
  });

  /* carrito */
  function setCount(n) {
    document.querySelectorAll('[data-bp-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }
  function refreshCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refreshCount, 300); }); });

  var toast;
  function showToast(msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'bp-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = '<span>' + msg + '</span><a href="' + ROOT + 'cart">Ver carrito</a>';
    requestAnimationFrame(function () { toast.classList.add('is-show'); });
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-show'); }, 3600);
  }
  function flyHeart(fromEl) {
    var cart = document.querySelector('.bp-cart'); if (!cart || reduce) return;
    var a = fromEl.getBoundingClientRect(), b = cart.getBoundingClientRect();
    var h = document.createElement('div'); h.className = 'bp-flyheart'; h.innerHTML = HEART_SVG;
    h.style.left = (a.left + a.width / 2 - 17) + 'px'; h.style.top = (a.top + a.height / 2 - 17) + 'px';
    document.body.appendChild(h);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      h.style.transform = 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' + (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(.5) rotate(20deg)';
      h.style.opacity = '.3';
    }); });
    setTimeout(function () { h.remove(); cart.classList.remove('is-bump'); void cart.offsetWidth; cart.classList.add('is-bump'); }, 900);
  }
  document.querySelectorAll('form[data-bp-quickadd]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { flyHeart(btn || form); refreshCount(); showToast('¡Añadido con mucho cariño!'); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
    });
  });

  /* hero: huellitas que siguen al ratón */
  var hero = document.querySelector('[data-bp-hero]');
  if (hero && finePointer) {
    var last = null, live = 0, side = 1;
    hero.addEventListener('pointermove', function (e) {
      if (e.target.closest('a,button,[data-bp-stage]')) return;
      var r = hero.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      if (last && Math.hypot(x - last.x, y - last.y) < 70) return;
      if (live > 14) return;
      var ang = last ? Math.atan2(y - last.y, x - last.x) * 180 / Math.PI + 90 : 0;
      side = -side;
      var p = document.createElement('span'); p.className = 'bp-pawprint'; p.innerHTML = PAW;
      var rad = ang * Math.PI / 180, off = 9 * side;
      p.style.left = (x - 11 + Math.cos(rad) * off) + 'px';
      p.style.top = (y - 11 + Math.sin(rad) * off) + 'px';
      p.style.rotate = ang + 'deg';
      hero.appendChild(p); live++;
      setTimeout(function () { p.remove(); live--; }, 1600);
      last = { x: x, y: y };
    });
    var blobs = hero.querySelectorAll('.bp-blob');
    hero.addEventListener('pointermove', function (e) {
      var nx = e.clientX / window.innerWidth - .5, ny = e.clientY / window.innerHeight - .5;
      blobs.forEach(function (b, i) { var k = (i + 1) * 18; b.style.transform = 'translate(' + (nx * k) + 'px,' + (ny * k) + 'px)'; });
    });
  }

  function burst(x, y) {
    if (!hero) return;
    var r = hero.getBoundingClientRect();
    for (var i = 0; i < 10; i++) {
      var s = document.createElement('span'); s.className = 'bp-burst'; s.innerHTML = HEART_SVG;
      var a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 90;
      s.style.left = (x - r.left - 9) + 'px'; s.style.top = (y - r.top - 9) + 'px';
      s.style.setProperty('--x', Math.cos(a) * d + 'px'); s.style.setProperty('--y', Math.sin(a) * d - 40 + 'px');
      s.style.setProperty('--r', (Math.random() * 120 - 60) + 'deg');
      hero.appendChild(s); setTimeout(function (el) { el.remove(); }.bind(null, s), 1000);
    }
  }

  /* hero: escena 3D */
  var stage = document.querySelector('[data-bp-stage]');
  if (stage) {
    var tries = 0;
    var start = function () {
      if (window.THREE) { try { initScene(stage); } catch (err) { if (window.console) console.warn('Bellapoopis 3D:', err); } return; }
      if (++tries < 200) setTimeout(start, 100);
    };
    start();
  }

  function initScene(stage) {
    var THREE = window.THREE;
    var canvas = stage.querySelector('canvas');
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'default' }); } catch (e) { return; }
    if (!renderer.getContext()) return;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(32, 1, 0.1, 100);
    camera.position.set(0, 0, 10.5);

    scene.add(new THREE.HemisphereLight(0xffffff, 0xd98c7a, 0.55));
    var key = new THREE.DirectionalLight(0xffffff, 0.75); key.position.set(3, 5, 6); scene.add(key);
    var rim = new THREE.DirectionalLight(0xffd6c8, 0.45); rim.position.set(-5, -2, -4); scene.add(rim);
    var fill = new THREE.PointLight(0xffe3d6, 0.35, 30); fill.position.set(-4, 3, 5); scene.add(fill);

    function mat(color, rough) { return new THREE.MeshStandardMaterial({ color: color, roughness: rough == null ? .38 : rough, metalness: .02 }); }
    var col = { coral: 0xF07F6A, cream: 0xFFF4E8, cocoa: 0x4A3134, mint: 0xA9DCCB, peach: 0xFFD2C0, butter: 0xFFE59E };

    function heartShape(s) {
      var sh = new THREE.Shape();
      function p(x, y) { return [(x - 100) / 100 * s, -(y - 100) / 100 * s]; }
      var m = p(100, 186); sh.moveTo(m[0], m[1]);
      var c = [[56,158,8,124,8,74],[8,38,34,14,66,14],[82,14,94,22,100,34],[106,22,118,14,134,14],[166,14,192,38,192,74],[192,124,144,158,100,186]];
      c.forEach(function (q) { var a = p(q[0], q[1]), b = p(q[2], q[3]), d = p(q[4], q[5]); sh.bezierCurveTo(a[0], a[1], b[0], b[1], d[0], d[1]); });
      return sh;
    }
    var depth = .42, bevel = .16;
    var hGeo = new THREE.ExtrudeGeometry(heartShape(1.5), { depth: depth, bevelEnabled: true, bevelThickness: bevel, bevelSize: .12, bevelSegments: 10, curveSegments: 48 });
    hGeo.translate(0, 0, -depth / 2);
    var heartGroup = new THREE.Group();
    heartGroup.add(new THREE.Mesh(hGeo, new THREE.MeshStandardMaterial({ color: col.coral, roughness: .28, metalness: .04 })));

    /* calcomanía: siluetas del logo */
    var tc = document.createElement('canvas'); tc.width = tc.height = 1024;
    var g = tc.getContext('2d'); g.scale(1024 / 300, 1024 / 300); g.translate(50, 50);
    g.translate(101, 104); g.scale(.88, .88); g.translate(-101, -108);
    g.fillStyle = g.strokeStyle = '#FFF4E8'; g.lineCap = g.lineJoin = 'round';
    function fp(d) { g.fill(new Path2D(d)); }
    function sp(d, w) { g.lineWidth = w; g.stroke(new Path2D(d)); }
    function el(cx, cy, rx, ry, rot) { g.beginPath(); g.ellipse(cx, cy, rx, ry, rot * Math.PI / 180, 0, Math.PI * 2); g.fill(); }
    fp('M58 152 C51 126 59 98 72 84 Q80 79 88 84 C101 98 108 126 101 152 Q80 158 58 152 Z');
    el(80, 66, 18, 18, 0); el(63, 71, 7, 14, 18); el(97, 71, 7, 14, -18);
    sp('M60 145 C46 143 41 130 46 116', 8);
    fp('M109 152 C104 130 110 108 119 96 Q126 91 133 96 C142 108 148 130 143 152 Q126 157 109 152 Z');
    el(126, 84, 14, 14, 0);
    g.lineWidth = 4; ['M114.5 80 L114.5 64 L124 73 Z', 'M137.5 80 L137.5 64 L128 73 Z'].forEach(function (d) { var pth = new Path2D(d); g.fill(pth); g.stroke(pth); });
    sp('M142 147 C157 148 161 134 154 122 C151 117 153 112 158 111', 6.5);
    var tex = new THREE.CanvasTexture(tc);
    tex.anisotropy = 4;
    var decalMat = new THREE.MeshStandardMaterial({ map: tex, transparent: true, roughness: .45, depthWrite: false });
    var front = new THREE.Mesh(new THREE.PlaneGeometry(4.5, 4.5), decalMat);
    front.position.z = depth / 2 + bevel + .006; heartGroup.add(front);
    var back = front.clone(); back.rotation.y = Math.PI; back.position.z = -front.position.z; heartGroup.add(back);
    scene.add(heartGroup);

    /* juguetes flotantes */
    var toys = [];
    function addToy(mesh, x, y, z, s, speed) {
      x *= .82; y *= .82; mesh.position.set(x, y, z); mesh.scale.setScalar(s);
      mesh.userData = { base: new THREE.Vector3(x, y, z), ph: Math.random() * 6.28, sp: speed || 1, rot: new THREE.Vector3(Math.random() * .6, Math.random() * .8, Math.random() * .4) };
      scene.add(mesh); toys.push(mesh);
    }
    function ellipse(cx, cy, rx, ry) { var s = new THREE.Shape(); s.absellipse(cx, cy, rx, ry, 0, Math.PI * 2, false, 0); return s; }
    function pawGeo() {
      var shapes = [ellipse(0, -.2, .55, .45)];
      [[-.62, .32, .2, .26], [-.24, .7, .2, .27], [.24, .7, .2, .27], [.62, .32, .2, .26]].forEach(function (t) { shapes.push(ellipse(t[0], t[1], t[2], t[3])); });
      var geo = new THREE.ExtrudeGeometry(shapes, { depth: .16, bevelEnabled: true, bevelThickness: .08, bevelSize: .06, bevelSegments: 4, curveSegments: 24 });
      geo.center(); return geo;
    }
    function boneGeo() {
      var shapes = [];
      var r = new THREE.Shape(); r.moveTo(-.72, -.15); r.lineTo(.72, -.15); r.lineTo(.72, .15); r.lineTo(-.72, .15); r.lineTo(-.72, -.15); shapes.push(r);
      [[-.78, .2], [-.78, -.2], [.78, .2], [.78, -.2]].forEach(function (c) { shapes.push(ellipse(c[0], c[1], .22, .22)); });
      var geo = new THREE.ExtrudeGeometry(shapes, { depth: .14, bevelEnabled: true, bevelThickness: .08, bevelSize: .06, bevelSegments: 5, curveSegments: 20 });
      geo.center(); return geo;
    }
    var sphere = new THREE.SphereGeometry(.5, 48, 32);
    addToy(new THREE.Mesh(pawGeo(), mat(col.cocoa, .5)), -2.55, 1.55, .4, .62, .9);
    addToy(new THREE.Mesh(pawGeo(), mat(col.coral, .35)), 2.45, -1.75, .9, .5, 1.1);
    addToy(new THREE.Mesh(boneGeo(), mat(col.cream, .5)), 2.35, 1.75, -.4, .78, .8);
    addToy(new THREE.Mesh(sphere, mat(col.mint, .3)), -2.3, -1.45, .8, .78, 1.2);
    addToy(new THREE.Mesh(sphere, mat(col.butter, .3)), 1.15, 2.35, -1.2, .46, 1);
    addToy(new THREE.Mesh(new THREE.TorusGeometry(.42, .18, 24, 64), mat(col.peach, .35)), -1.25, -2.3, -.6, .9, .7);
    var mini = new THREE.ExtrudeGeometry(heartShape(.5), { depth: .12, bevelEnabled: true, bevelThickness: .06, bevelSize: .05, bevelSegments: 5, curveSegments: 24 });
    mini.center();
    addToy(new THREE.Mesh(mini, mat(col.cream, .4)), -.6, 2.45, .3, .9, 1.3);

    /* interacción */
    var target = { x: 0, y: 0 }, cur = { x: 0, y: 0 };
    var drag = { on: false, x: 0, vel: 0, rot: 0 }, spin = 0, scrollK = 0;
    window.addEventListener('pointermove', function (e) {
      target.x = (e.clientX / window.innerWidth) * 2 - 1;
      target.y = (e.clientY / window.innerHeight) * 2 - 1;
      if (drag.on) { var dx = e.clientX - drag.x; drag.x = e.clientX; drag.vel = dx * .012; drag.rot += drag.vel; }
    }, { passive: true });
    stage.addEventListener('pointerdown', function (e) { drag.on = true; drag.x = e.clientX; drag.start = e.clientX; drag.t = Date.now(); });
    window.addEventListener('pointerup', function (e) {
      if (!drag.on) return; drag.on = false;
      if (Math.abs(e.clientX - drag.start) < 6 && Date.now() - drag.t < 300) { spin += Math.PI * 2; burst(e.clientX, e.clientY); }
    });
    window.addEventListener('scroll', function () { scrollK = Math.min(window.scrollY / window.innerHeight, 1.2); }, { passive: true });

    function resize() {
      var r = canvas.getBoundingClientRect(); var w = Math.max(1, r.width), h = Math.max(1, r.height);
      renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
    }
    resize(); window.addEventListener('resize', resize);
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(stage);

    var clock = new THREE.Clock(), spinCur = 0;
    function tick() {
      requestAnimationFrame(tick);
      var r = stage.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var t = clock.getElapsedTime();
      cur.x += (target.x - cur.x) * .05; cur.y += (target.y - cur.y) * .05;
      if (!drag.on) { drag.vel *= .94; drag.rot += drag.vel; drag.rot *= .985; }
      spinCur += (spin - spinCur) * .06;
      heartGroup.rotation.y = Math.sin(t * .7) * .45 + cur.x * .55 + drag.rot + spinCur + scrollK * 1.4;
      heartGroup.rotation.x = cur.y * .3 + Math.sin(t * .9) * .06 - scrollK * .3;
      heartGroup.position.y = Math.sin(t * 1.4) * .12;
      var sc = 1 + Math.sin(t * 2.6) * .012; heartGroup.scale.set(sc, sc, sc);
      toys.forEach(function (m, i) {
        var u = m.userData;
        m.position.x = u.base.x - cur.x * (.3 + i * .05) * (u.base.z + 2) * .35;
        m.position.y = u.base.y + Math.sin(t * u.sp + u.ph) * .18 + cur.y * .25 * (u.base.z + 2) * .3 + scrollK * (i % 2 ? 1 : -1) * .8;
        m.rotation.x = u.rot.x + t * .3 * u.sp; m.rotation.y = u.rot.y + t * .45 * u.sp; m.rotation.z = u.rot.z + Math.sin(t + u.ph) * .3;
      });
      camera.position.z = 10.5 + scrollK * 2.5;
      renderer.render(scene, camera);
    }
    tick();
    stage.classList.add('is-3d');
  }

  refreshCount();
})();
